import SkillzStyle from 'SkillzStyle';
import {StyleSheet, Platform} from 'react-native';

export default () => {
  return StyleSheet.create({
    backdrop: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: SkillzStyle.convertToOpacity('#000000', 0.6),
      ...Platform.select({
        web: {
          width: '100%',
        },
      }),
    },
    container: {
      flex: 1,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
    },
    houseAdHeroBgSmallDevicesTablets: {
      left: 'auto',
      width: '100%',
      height: '100%',
      alignSelf: 'center',
    },
  });
};
